import './src/css/styles.css';

/**
 *
 * Initial code borrowed from https://github.com/gatsbyjs/gatsby/tree/master/packages/gatsby-plugin-google-tagmanager
 */
export function onRouteUpdate({ location }) {
    if (process.env.GATSBY_ENV === `production`) {
        // wrap inside a timeout to ensure the title has properly been changed
        setTimeout(() => {
            const uuid = window.crypto.randomUUID();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pageview',
                event_id: uuid,
                page: location.pathname + location.search + location.hash
            });
        }, 50);
    }
}
